import { combineReducers } from 'redux';
import authReducer from './authSlice';
import homeReducer from './homeSlice';
import commonReducer from './commonSlice';

const rootReducer = combineReducers({
  authReducer,
  homeReducer,
  commonReducer,
});
// eslint-disable-next-line
export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
